import React, { useState } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';

const NewsletterSubscription = () => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [newsletterMessage, setNewsletterMessage] = useState('');

  const handleNewsletterSubmit = (event) => {
    event.preventDefault();
    if (email.trim() !== '' && firstName.trim() !== '' && lastName.trim() !== '') {
      setEmail('');
      setFirstName('');
      setLastName('');
      setNewsletterMessage('Subscription successful. Please check your email to confirm.');
      setTimeout(() => setNewsletterMessage(''), 4000);
    }
  };

  return (

    <Box component="form" onSubmit={handleNewsletterSubmit}
      sx={{
        position: { xs: 'static', md: 'absolute' },
        top: { md: 200 },
        right: { md: 10 },
        width: { xs: '90%', md: 300 },
        border: '2px solid #cdcfd2',
        borderRadius: '2rem',
        p: 2,
        mt: { xs: 3, md: 5, lg: 10 },
        mb: { xs: 2, md: 0 },
        mx: { xs: 2, md: 2 },
        backgroundColor: 'white',
        zIndex: 10
      }}>

      <Typography variant="h6" sx={{ mb: 2 }}>SIGN UP FOR BEADS NEWSLETTERS</Typography>
      <TextField label="First Name" variant="outlined" fullWidth sx={{ mb: 1 }} value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
      <TextField label="Last Name" variant="outlined" fullWidth sx={{ mb: 1 }} value={lastName} onChange={(e) => setLastName(e.target.value)} required />
      <TextField label="Email Address" variant="outlined" fullWidth sx={{ mb: 2 }} value={email} onChange={(e) => setEmail(e.target.value)} required type="email" />

      <Button type="submit" variant="contained" fullWidth sx={{
        // color: '#f39c12',
        borderRadius: '2rem',
        height: '42px',
        ':hover': {
          borderColor: '#f39c12',
          backgroundColor: '#f39c12',
          color: '#fff'
        },
      }}>
        Subscribe Now
      </Button>

      {newsletterMessage && (
        <Typography sx={{ mt: 2, backgroundColor: '#cfcfcf', borderRadius: '1.2rem', p: 1, textAlign: 'center' }}>
          {newsletterMessage}
        </Typography>
      )}
    </Box>
  );
};

export default NewsletterSubscription;
